import { withDependencyWrites } from './write-intents';
import type { PortWithWrites } from '../../port-contract';
import * as php from '../../php-compat';
import { get, values, isArray } from './shared';
import { call, r, put, type Ref, type DispatchEnv } from './dispatch';
/** PHP: trigger_post_roll_passives (includes/functions/janus/core/trigger_post_roll_passives.php:23) */
export function triggerPostRollPassives(caster: Ref, affected: Ref, item: unknown, roll: unknown, connected: unknown, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => {
    if (env.deps.layer_value(item, 'roll_type') === null) return null;
    const passives = [...values(env.deps.layer_entries(caster.value, 'passive_ability')), ...values(env.deps.ft_status_item_passive_entries(caster.value))];
    if (!passives.length) return null;
    const type = env.deps.layer_value(item, 'roll_type');
    for (const entry of passives) {
        if (!isArray(entry) || !php.truthy(env.deps.passive_ability_entry_is_active(entry))) continue;
        const passive = { value: php.phpCopy(entry) };
        if (php.truthy(env.deps.ft_layer_entry_needs_resolve(get(passive.value, 'item_arr') ?? get(passive.value, 'item_id') ?? null)))
            put(passive, ['item_arr'], env.deps.ft_resolve_layer_entry(get(passive.value, 'item_arr') ?? get(passive.value, 'item_id'), caster.value));
        const def = get(passive.value, 'item_arr');
        if (isArray(def) && php.in_array(type, env.deps.ft_normalize_layer_entries_to_distinct_uuids(env.deps.layer_entries(def, 'triggers_when_caster_makes_roll_type')) as import('../../php-compat').PhpArrayInput, true))
            call(env, 'remove_status_effects', { item_id_used_arr: def, item_layer_type_name: 'status_effect_removed_from_target_after_cast', caster_arr: r(caster), target_arr: r(caster), affected_ids: r(affected), roll_id: roll, status_connected_id: connected });
    }
return null;

 });
}
